import momentTimezone from 'moment-timezone';

export const getFormattedLocalDate = (date, format = 'YYYY-MM-DD') => momentTimezone(date).local().format(format)
export const getFormattedLocalTime = (date) => momentTimezone(date).local().format('h:mm A')
export const getFormattedLocalDateTime = (date) => momentTimezone(date).local().format()
export const addDurationToLocalTime = (date, duration, durationType = 'minutes') => momentTimezone(date).add(duration, durationType).format('h:mm A')
export const getTimeZone = () => momentTimezone().tz(momentTimezone.tz.guess()).format('z');
